import React, { PureComponent } from "react"
// import style from "./Home2.module.css"

class Home2 extends PureComponent {
  render() {
    return (
      <div
        style={{
          display: "flex",
          width: "610px",
          height: "610px",
          border: "1px solid black",
          alignContent: "space-between",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            border: "1px solid black",
            width: "100px",
            margin: "30px 30px",
            height: "100px",
            borderRadius: "100px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          1
        </div>
        <div
          style={{
            border: "1px solid black",
            width: "100px",
            margin: "30px 30px",
            height: "100px",
            borderRadius: "100px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            alignSelf: "flex-end",
          }}
        >
          2
        </div>
      </div>
    )
  }
}

export default Home2
